import React, {useState} from "react";
import { useTranslate } from 'react-redux-multilingual';
import { CSVReader } from 'react-papaparse';
import axios from 'axios';
import swal from "sweetalert2";

const CsvImportInventoryZone = (props) => {
    const t = useTranslate();
    const [csvData,setCsvData] = useState(false);
    const [errorCsv,setErrorCsv] = useState(false);
    const [apiError,setApiError] = useState(false);
    const [validButton,setValidButton] = useState(false);
    const [resetCsv,setResetCsv] = useState(false);

    const handleOnDrop = (data,file) => {
        setApiError(false);
        setErrorCsv(false);
        setResetCsv(false);

        const fileSizeInMegabytes = file.size / (1024 * 1024);
        if(fileSizeInMegabytes > 7){
            setErrorCsv(t('fileCsvToLarge'));
            return;
        }
        const csvImportLimit = Number(process.env.REACT_APP_CSV_IMPORT_LIMIT || 50000);
        if(data.length > csvImportLimit){
            setErrorCsv(t('limitCsv',{limit: csvImportLimit}));
            return;
        }
        let recupData = data.map((value,index) => ({
            line: index+1,
            value: value.data[0] === undefined ? '' : value.data[0]
        }));
        if(recupData.every(item => item.value.trim() === '')){
            setErrorCsv(t('noDataInCsv'));
            return;
        }
        setCsvData(recupData);
    };

    const handleOnError = () => {
        setErrorCsv(t('unknowError'));
        setCsvData(false);
    };

    const handleOnRemoveFile = () => {
        setErrorCsv(false);
        setApiError(false);
        setCsvData(false);
    };

    const goImport = async () => {
        setValidButton(true);
        setApiError(false);

        await axios.post(process.env.REACT_APP_API_URL+"api/erp/inventaire_division/csv_import_zone_inventaire/"+props.inventaireId,{
            list: csvData
        }).then((response) => {
            if(!response.data.valid){
                setApiError(t('unknowError'));
                return;
            }

            props.setAllInventoryZone({...props.allInventoryZone, inventaire_division: response.data.data.inventaire_division});
            props.setAfficheTabZone(response.data.data.inventaire_division.slice(0,50));

            if(response.data.errors.length !== 0){
                let interms = '';
                response.data.errors.forEach(item => {
                    const messages=item.errors.map(message => t(message)).join(', ');
                    interms += t('csvLineError',{line:item.line, value:item.value || '-', errors:messages})+'<br>';
                });
                swal.fire({
                    icon: 'warning',
                    title: t('zoneCsvImportPartial',{inserted: response.data.totalImport, total: response.data.totalLines}),
                    html: interms
                });
            }else{
                swal.fire({icon: 'success', title: t('zoneCsvImportSuccess',{inserted: response.data.totalImport})});
            }

            setCsvData(false);
            setResetCsv(true);
        }).catch((error) => {
            if(error=='end_session') return;
            let errorName = (error.response==undefined) ? 'unknowError' : (error.response.status==403) ? 'forbiddenGeneral' : 'unknowError';
            setApiError(t(errorName));
        });

        setValidButton(false);
    };

    return (
        <>
            <CSVReader
                onDrop={handleOnDrop}
                onError={handleOnError}
                addRemoveButton
                onRemoveFile={handleOnRemoveFile}
                isReset={resetCsv}
                config={{
                    delimiter: props.authParam.company.advanceparams.csv_separator,
                    encoding: props.authParam.company.advanceparams.csv_encode
                }}
            >
                <span>{t('dropCsv')}</span>
            </CSVReader>
            <small className="form-text text-muted">{t('zoneCsvNoHeaderHelp')}</small>
            {(errorCsv) && <div className="alert alert-danger text-center mt-2">{errorCsv}</div>}
            {(apiError) && <div className="alert alert-danger text-center mt-2">{apiError}</div>}
            {(csvData && !errorCsv) &&
                <div className="col-12 text-center mt-3">
                    <button disabled={validButton} className="btn btn-primary" onClick={() => goImport()}>
                        {validButton ? <div className="spinner-border spinner-border-sm"></div> : t('btnInsert')}
                    </button>
                </div>
            }
        </>
    );
};

export default CsvImportInventoryZone;
